<ngx-spinner [name]="name??'content-loader'" color='#35A291' bdColor="{{bdColor}}" size="medium" type="ball-clip-rotate-multiple" [fullScreen]="false">
  <p style="color:#35A291"> {{'LOADING'|translate}}...</p>
</ngx-spinner>
